import { render, staticRenderFns } from "./ArchivesList.vue?vue&type=template&id=17e207dc"
import script from "./ArchivesList.vue?vue&type=script&lang=js"
export * from "./ArchivesList.vue?vue&type=script&lang=js"
import style0 from "./ArchivesList.vue?vue&type=style&index=0&id=17e207dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports